import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class AdminCentralService {

    constructor(private httpClient: HttpClient) {
    }

    getResourcesFromAppointment(userId: number): Observable<any> {
        return this.httpClient
            .get<{ resources: Array<String> }>(`servlets/appointmentresources/resources/?userid=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.appointmentResources)
            );
    }
}
